import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6689ba87 = () => interopDefault(import('../../../pages/appointment/index.vue' /* webpackChunkName: "pages/appointment/index" */))
const _71d90077 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _885e9e1c = () => interopDefault(import('../../../pages/form/index.vue' /* webpackChunkName: "pages/form/index" */))
const _82811174 = () => interopDefault(import('../../../pages/appointment/clinic/index.vue' /* webpackChunkName: "pages/appointment/clinic/index" */))
const _30315d9e = () => interopDefault(import('../../../pages/appointment/login.vue' /* webpackChunkName: "pages/appointment/login" */))
const _2f5a2038 = () => interopDefault(import('../../../pages/appointment/password-reset.vue' /* webpackChunkName: "pages/appointment/password-reset" */))
const _4f128fbd = () => interopDefault(import('../../../pages/appointment/password-reset-sent.vue' /* webpackChunkName: "pages/appointment/password-reset-sent" */))
const _22544333 = () => interopDefault(import('../../../pages/appointment/signup.vue' /* webpackChunkName: "pages/appointment/signup" */))
const _1a881e9e = () => interopDefault(import('../../../pages/appointment/termsOfServices.vue' /* webpackChunkName: "pages/appointment/termsOfServices" */))
const _3c08b6e6 = () => interopDefault(import('../../../pages/appointment/visits/index.vue' /* webpackChunkName: "pages/appointment/visits/index" */))
const _4a14fb0a = () => interopDefault(import('../../../pages/form/clinic/index.vue' /* webpackChunkName: "pages/form/clinic/index" */))
const _6811d80e = () => interopDefault(import('../../../pages/appointment/clinic/_clinicId/index.vue' /* webpackChunkName: "pages/appointment/clinic/_clinicId/index" */))
const _21aa26a4 = () => interopDefault(import('../../../pages/appointment/menu/_menuId.vue' /* webpackChunkName: "pages/appointment/menu/_menuId" */))
const _43b460ee = () => interopDefault(import('../../../pages/form/clinic/_clinicId/index.vue' /* webpackChunkName: "pages/form/clinic/_clinicId/index" */))
const _91046ffc = () => interopDefault(import('../../../pages/appointment/visits/_appointmentId/cancel.vue' /* webpackChunkName: "pages/appointment/visits/_appointmentId/cancel" */))
const _2be8baa1 = () => interopDefault(import('../../../pages/appointment/visits/_appointmentId/canceled.vue' /* webpackChunkName: "pages/appointment/visits/_appointmentId/canceled" */))
const _94f1f3e2 = () => interopDefault(import('../../../pages/appointment/schedule/_scheduleId/_index/confirm.vue' /* webpackChunkName: "pages/appointment/schedule/_scheduleId/_index/confirm" */))
const _d58a6892 = () => interopDefault(import('../../../pages/appointment/schedule/_scheduleId/_index/patient-info.vue' /* webpackChunkName: "pages/appointment/schedule/_scheduleId/_index/patient-info" */))
const _3fcd606c = () => interopDefault(import('../../../pages/appointment/reschedule/_appointmentId/_scheduleId/_index/confirm.vue' /* webpackChunkName: "pages/appointment/reschedule/_appointmentId/_scheduleId/_index/confirm" */))
const _2d0b4aac = () => interopDefault(import('../../../pages/appointment/schedule/_scheduleId/_index/_appointmentId/confirmed.vue' /* webpackChunkName: "pages/appointment/schedule/_scheduleId/_index/_appointmentId/confirmed" */))
const _faf0353a = () => interopDefault(import('../../../pages/s/_shortLinkPath.vue' /* webpackChunkName: "pages/s/_shortLinkPath" */))
const _5dcc4f6f = () => interopDefault(import('../../../pages/form/_formId/confirm.vue' /* webpackChunkName: "pages/form/_formId/confirm" */))
const _400f4f69 = () => interopDefault(import('../../../pages/form/_formId/loadBackup.vue' /* webpackChunkName: "pages/form/_formId/loadBackup" */))
const _f511210e = () => interopDefault(import('../../../pages/form/_formId/sent.vue' /* webpackChunkName: "pages/form/_formId/sent" */))
const _b8619c4a = () => interopDefault(import('../../../pages/form/_formId/_pageId/index.vue' /* webpackChunkName: "pages/form/_formId/_pageId/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/appointment",
    component: _6689ba87,
    name: "appointment___ja"
  }, {
    path: "/en",
    component: _71d90077,
    name: "index___en"
  }, {
    path: "/es",
    component: _71d90077,
    name: "index___es"
  }, {
    path: "/form",
    component: _885e9e1c,
    name: "form___ja"
  }, {
    path: "/fr",
    component: _71d90077,
    name: "index___fr"
  }, {
    path: "/ko",
    component: _71d90077,
    name: "index___ko"
  }, {
    path: "/ne",
    component: _71d90077,
    name: "index___ne"
  }, {
    path: "/pt",
    component: _71d90077,
    name: "index___pt"
  }, {
    path: "/th",
    component: _71d90077,
    name: "index___th"
  }, {
    path: "/tl",
    component: _71d90077,
    name: "index___tl"
  }, {
    path: "/vi",
    component: _71d90077,
    name: "index___vi"
  }, {
    path: "/zhCn",
    component: _71d90077,
    name: "index___zhCn"
  }, {
    path: "/zhTw",
    component: _71d90077,
    name: "index___zhTw"
  }, {
    path: "/appointment/clinic",
    component: _82811174,
    name: "appointment-clinic___ja"
  }, {
    path: "/appointment/login",
    component: _30315d9e,
    name: "appointment-login___ja"
  }, {
    path: "/appointment/password-reset",
    component: _2f5a2038,
    name: "appointment-password-reset___ja"
  }, {
    path: "/appointment/password-reset-sent",
    component: _4f128fbd,
    name: "appointment-password-reset-sent___ja"
  }, {
    path: "/appointment/signup",
    component: _22544333,
    name: "appointment-signup___ja"
  }, {
    path: "/appointment/termsOfServices",
    component: _1a881e9e,
    name: "appointment-termsOfServices___ja"
  }, {
    path: "/appointment/visits",
    component: _3c08b6e6,
    name: "appointment-visits___ja"
  }, {
    path: "/en/appointment",
    component: _6689ba87,
    name: "appointment___en"
  }, {
    path: "/en/form",
    component: _885e9e1c,
    name: "form___en"
  }, {
    path: "/es/appointment",
    component: _6689ba87,
    name: "appointment___es"
  }, {
    path: "/es/form",
    component: _885e9e1c,
    name: "form___es"
  }, {
    path: "/form/clinic",
    component: _4a14fb0a,
    name: "form-clinic___ja"
  }, {
    path: "/fr/appointment",
    component: _6689ba87,
    name: "appointment___fr"
  }, {
    path: "/fr/form",
    component: _885e9e1c,
    name: "form___fr"
  }, {
    path: "/ko/appointment",
    component: _6689ba87,
    name: "appointment___ko"
  }, {
    path: "/ko/form",
    component: _885e9e1c,
    name: "form___ko"
  }, {
    path: "/ne/appointment",
    component: _6689ba87,
    name: "appointment___ne"
  }, {
    path: "/ne/form",
    component: _885e9e1c,
    name: "form___ne"
  }, {
    path: "/pt/appointment",
    component: _6689ba87,
    name: "appointment___pt"
  }, {
    path: "/pt/form",
    component: _885e9e1c,
    name: "form___pt"
  }, {
    path: "/th/appointment",
    component: _6689ba87,
    name: "appointment___th"
  }, {
    path: "/th/form",
    component: _885e9e1c,
    name: "form___th"
  }, {
    path: "/tl/appointment",
    component: _6689ba87,
    name: "appointment___tl"
  }, {
    path: "/tl/form",
    component: _885e9e1c,
    name: "form___tl"
  }, {
    path: "/vi/appointment",
    component: _6689ba87,
    name: "appointment___vi"
  }, {
    path: "/vi/form",
    component: _885e9e1c,
    name: "form___vi"
  }, {
    path: "/zhCn/appointment",
    component: _6689ba87,
    name: "appointment___zhCn"
  }, {
    path: "/zhCn/form",
    component: _885e9e1c,
    name: "form___zhCn"
  }, {
    path: "/zhTw/appointment",
    component: _6689ba87,
    name: "appointment___zhTw"
  }, {
    path: "/zhTw/form",
    component: _885e9e1c,
    name: "form___zhTw"
  }, {
    path: "/en/appointment/clinic",
    component: _82811174,
    name: "appointment-clinic___en"
  }, {
    path: "/en/appointment/login",
    component: _30315d9e,
    name: "appointment-login___en"
  }, {
    path: "/en/appointment/password-reset",
    component: _2f5a2038,
    name: "appointment-password-reset___en"
  }, {
    path: "/en/appointment/password-reset-sent",
    component: _4f128fbd,
    name: "appointment-password-reset-sent___en"
  }, {
    path: "/en/appointment/signup",
    component: _22544333,
    name: "appointment-signup___en"
  }, {
    path: "/en/appointment/termsOfServices",
    component: _1a881e9e,
    name: "appointment-termsOfServices___en"
  }, {
    path: "/en/appointment/visits",
    component: _3c08b6e6,
    name: "appointment-visits___en"
  }, {
    path: "/en/form/clinic",
    component: _4a14fb0a,
    name: "form-clinic___en"
  }, {
    path: "/es/appointment/clinic",
    component: _82811174,
    name: "appointment-clinic___es"
  }, {
    path: "/es/appointment/login",
    component: _30315d9e,
    name: "appointment-login___es"
  }, {
    path: "/es/appointment/password-reset",
    component: _2f5a2038,
    name: "appointment-password-reset___es"
  }, {
    path: "/es/appointment/password-reset-sent",
    component: _4f128fbd,
    name: "appointment-password-reset-sent___es"
  }, {
    path: "/es/appointment/signup",
    component: _22544333,
    name: "appointment-signup___es"
  }, {
    path: "/es/appointment/termsOfServices",
    component: _1a881e9e,
    name: "appointment-termsOfServices___es"
  }, {
    path: "/es/appointment/visits",
    component: _3c08b6e6,
    name: "appointment-visits___es"
  }, {
    path: "/es/form/clinic",
    component: _4a14fb0a,
    name: "form-clinic___es"
  }, {
    path: "/fr/appointment/clinic",
    component: _82811174,
    name: "appointment-clinic___fr"
  }, {
    path: "/fr/appointment/login",
    component: _30315d9e,
    name: "appointment-login___fr"
  }, {
    path: "/fr/appointment/password-reset",
    component: _2f5a2038,
    name: "appointment-password-reset___fr"
  }, {
    path: "/fr/appointment/password-reset-sent",
    component: _4f128fbd,
    name: "appointment-password-reset-sent___fr"
  }, {
    path: "/fr/appointment/signup",
    component: _22544333,
    name: "appointment-signup___fr"
  }, {
    path: "/fr/appointment/termsOfServices",
    component: _1a881e9e,
    name: "appointment-termsOfServices___fr"
  }, {
    path: "/fr/appointment/visits",
    component: _3c08b6e6,
    name: "appointment-visits___fr"
  }, {
    path: "/fr/form/clinic",
    component: _4a14fb0a,
    name: "form-clinic___fr"
  }, {
    path: "/ko/appointment/clinic",
    component: _82811174,
    name: "appointment-clinic___ko"
  }, {
    path: "/ko/appointment/login",
    component: _30315d9e,
    name: "appointment-login___ko"
  }, {
    path: "/ko/appointment/password-reset",
    component: _2f5a2038,
    name: "appointment-password-reset___ko"
  }, {
    path: "/ko/appointment/password-reset-sent",
    component: _4f128fbd,
    name: "appointment-password-reset-sent___ko"
  }, {
    path: "/ko/appointment/signup",
    component: _22544333,
    name: "appointment-signup___ko"
  }, {
    path: "/ko/appointment/termsOfServices",
    component: _1a881e9e,
    name: "appointment-termsOfServices___ko"
  }, {
    path: "/ko/appointment/visits",
    component: _3c08b6e6,
    name: "appointment-visits___ko"
  }, {
    path: "/ko/form/clinic",
    component: _4a14fb0a,
    name: "form-clinic___ko"
  }, {
    path: "/ne/appointment/clinic",
    component: _82811174,
    name: "appointment-clinic___ne"
  }, {
    path: "/ne/appointment/login",
    component: _30315d9e,
    name: "appointment-login___ne"
  }, {
    path: "/ne/appointment/password-reset",
    component: _2f5a2038,
    name: "appointment-password-reset___ne"
  }, {
    path: "/ne/appointment/password-reset-sent",
    component: _4f128fbd,
    name: "appointment-password-reset-sent___ne"
  }, {
    path: "/ne/appointment/signup",
    component: _22544333,
    name: "appointment-signup___ne"
  }, {
    path: "/ne/appointment/termsOfServices",
    component: _1a881e9e,
    name: "appointment-termsOfServices___ne"
  }, {
    path: "/ne/appointment/visits",
    component: _3c08b6e6,
    name: "appointment-visits___ne"
  }, {
    path: "/ne/form/clinic",
    component: _4a14fb0a,
    name: "form-clinic___ne"
  }, {
    path: "/pt/appointment/clinic",
    component: _82811174,
    name: "appointment-clinic___pt"
  }, {
    path: "/pt/appointment/login",
    component: _30315d9e,
    name: "appointment-login___pt"
  }, {
    path: "/pt/appointment/password-reset",
    component: _2f5a2038,
    name: "appointment-password-reset___pt"
  }, {
    path: "/pt/appointment/password-reset-sent",
    component: _4f128fbd,
    name: "appointment-password-reset-sent___pt"
  }, {
    path: "/pt/appointment/signup",
    component: _22544333,
    name: "appointment-signup___pt"
  }, {
    path: "/pt/appointment/termsOfServices",
    component: _1a881e9e,
    name: "appointment-termsOfServices___pt"
  }, {
    path: "/pt/appointment/visits",
    component: _3c08b6e6,
    name: "appointment-visits___pt"
  }, {
    path: "/pt/form/clinic",
    component: _4a14fb0a,
    name: "form-clinic___pt"
  }, {
    path: "/th/appointment/clinic",
    component: _82811174,
    name: "appointment-clinic___th"
  }, {
    path: "/th/appointment/login",
    component: _30315d9e,
    name: "appointment-login___th"
  }, {
    path: "/th/appointment/password-reset",
    component: _2f5a2038,
    name: "appointment-password-reset___th"
  }, {
    path: "/th/appointment/password-reset-sent",
    component: _4f128fbd,
    name: "appointment-password-reset-sent___th"
  }, {
    path: "/th/appointment/signup",
    component: _22544333,
    name: "appointment-signup___th"
  }, {
    path: "/th/appointment/termsOfServices",
    component: _1a881e9e,
    name: "appointment-termsOfServices___th"
  }, {
    path: "/th/appointment/visits",
    component: _3c08b6e6,
    name: "appointment-visits___th"
  }, {
    path: "/th/form/clinic",
    component: _4a14fb0a,
    name: "form-clinic___th"
  }, {
    path: "/tl/appointment/clinic",
    component: _82811174,
    name: "appointment-clinic___tl"
  }, {
    path: "/tl/appointment/login",
    component: _30315d9e,
    name: "appointment-login___tl"
  }, {
    path: "/tl/appointment/password-reset",
    component: _2f5a2038,
    name: "appointment-password-reset___tl"
  }, {
    path: "/tl/appointment/password-reset-sent",
    component: _4f128fbd,
    name: "appointment-password-reset-sent___tl"
  }, {
    path: "/tl/appointment/signup",
    component: _22544333,
    name: "appointment-signup___tl"
  }, {
    path: "/tl/appointment/termsOfServices",
    component: _1a881e9e,
    name: "appointment-termsOfServices___tl"
  }, {
    path: "/tl/appointment/visits",
    component: _3c08b6e6,
    name: "appointment-visits___tl"
  }, {
    path: "/tl/form/clinic",
    component: _4a14fb0a,
    name: "form-clinic___tl"
  }, {
    path: "/vi/appointment/clinic",
    component: _82811174,
    name: "appointment-clinic___vi"
  }, {
    path: "/vi/appointment/login",
    component: _30315d9e,
    name: "appointment-login___vi"
  }, {
    path: "/vi/appointment/password-reset",
    component: _2f5a2038,
    name: "appointment-password-reset___vi"
  }, {
    path: "/vi/appointment/password-reset-sent",
    component: _4f128fbd,
    name: "appointment-password-reset-sent___vi"
  }, {
    path: "/vi/appointment/signup",
    component: _22544333,
    name: "appointment-signup___vi"
  }, {
    path: "/vi/appointment/termsOfServices",
    component: _1a881e9e,
    name: "appointment-termsOfServices___vi"
  }, {
    path: "/vi/appointment/visits",
    component: _3c08b6e6,
    name: "appointment-visits___vi"
  }, {
    path: "/vi/form/clinic",
    component: _4a14fb0a,
    name: "form-clinic___vi"
  }, {
    path: "/zhCn/appointment/clinic",
    component: _82811174,
    name: "appointment-clinic___zhCn"
  }, {
    path: "/zhCn/appointment/login",
    component: _30315d9e,
    name: "appointment-login___zhCn"
  }, {
    path: "/zhCn/appointment/password-reset",
    component: _2f5a2038,
    name: "appointment-password-reset___zhCn"
  }, {
    path: "/zhCn/appointment/password-reset-sent",
    component: _4f128fbd,
    name: "appointment-password-reset-sent___zhCn"
  }, {
    path: "/zhCn/appointment/signup",
    component: _22544333,
    name: "appointment-signup___zhCn"
  }, {
    path: "/zhCn/appointment/termsOfServices",
    component: _1a881e9e,
    name: "appointment-termsOfServices___zhCn"
  }, {
    path: "/zhCn/appointment/visits",
    component: _3c08b6e6,
    name: "appointment-visits___zhCn"
  }, {
    path: "/zhCn/form/clinic",
    component: _4a14fb0a,
    name: "form-clinic___zhCn"
  }, {
    path: "/zhTw/appointment/clinic",
    component: _82811174,
    name: "appointment-clinic___zhTw"
  }, {
    path: "/zhTw/appointment/login",
    component: _30315d9e,
    name: "appointment-login___zhTw"
  }, {
    path: "/zhTw/appointment/password-reset",
    component: _2f5a2038,
    name: "appointment-password-reset___zhTw"
  }, {
    path: "/zhTw/appointment/password-reset-sent",
    component: _4f128fbd,
    name: "appointment-password-reset-sent___zhTw"
  }, {
    path: "/zhTw/appointment/signup",
    component: _22544333,
    name: "appointment-signup___zhTw"
  }, {
    path: "/zhTw/appointment/termsOfServices",
    component: _1a881e9e,
    name: "appointment-termsOfServices___zhTw"
  }, {
    path: "/zhTw/appointment/visits",
    component: _3c08b6e6,
    name: "appointment-visits___zhTw"
  }, {
    path: "/zhTw/form/clinic",
    component: _4a14fb0a,
    name: "form-clinic___zhTw"
  }, {
    path: "/",
    component: _71d90077,
    name: "index___ja"
  }, {
    path: "/en/appointment/clinic/:clinicId",
    component: _6811d80e,
    name: "appointment-clinic-clinicId___en"
  }, {
    path: "/en/appointment/menu/:menuId?",
    component: _21aa26a4,
    name: "appointment-menu-menuId___en"
  }, {
    path: "/en/form/clinic/:clinicId",
    component: _43b460ee,
    name: "form-clinic-clinicId___en"
  }, {
    path: "/es/appointment/clinic/:clinicId",
    component: _6811d80e,
    name: "appointment-clinic-clinicId___es"
  }, {
    path: "/es/appointment/menu/:menuId?",
    component: _21aa26a4,
    name: "appointment-menu-menuId___es"
  }, {
    path: "/es/form/clinic/:clinicId",
    component: _43b460ee,
    name: "form-clinic-clinicId___es"
  }, {
    path: "/fr/appointment/clinic/:clinicId",
    component: _6811d80e,
    name: "appointment-clinic-clinicId___fr"
  }, {
    path: "/fr/appointment/menu/:menuId?",
    component: _21aa26a4,
    name: "appointment-menu-menuId___fr"
  }, {
    path: "/fr/form/clinic/:clinicId",
    component: _43b460ee,
    name: "form-clinic-clinicId___fr"
  }, {
    path: "/ko/appointment/clinic/:clinicId",
    component: _6811d80e,
    name: "appointment-clinic-clinicId___ko"
  }, {
    path: "/ko/appointment/menu/:menuId?",
    component: _21aa26a4,
    name: "appointment-menu-menuId___ko"
  }, {
    path: "/ko/form/clinic/:clinicId",
    component: _43b460ee,
    name: "form-clinic-clinicId___ko"
  }, {
    path: "/ne/appointment/clinic/:clinicId",
    component: _6811d80e,
    name: "appointment-clinic-clinicId___ne"
  }, {
    path: "/ne/appointment/menu/:menuId?",
    component: _21aa26a4,
    name: "appointment-menu-menuId___ne"
  }, {
    path: "/ne/form/clinic/:clinicId",
    component: _43b460ee,
    name: "form-clinic-clinicId___ne"
  }, {
    path: "/pt/appointment/clinic/:clinicId",
    component: _6811d80e,
    name: "appointment-clinic-clinicId___pt"
  }, {
    path: "/pt/appointment/menu/:menuId?",
    component: _21aa26a4,
    name: "appointment-menu-menuId___pt"
  }, {
    path: "/pt/form/clinic/:clinicId",
    component: _43b460ee,
    name: "form-clinic-clinicId___pt"
  }, {
    path: "/th/appointment/clinic/:clinicId",
    component: _6811d80e,
    name: "appointment-clinic-clinicId___th"
  }, {
    path: "/th/appointment/menu/:menuId?",
    component: _21aa26a4,
    name: "appointment-menu-menuId___th"
  }, {
    path: "/th/form/clinic/:clinicId",
    component: _43b460ee,
    name: "form-clinic-clinicId___th"
  }, {
    path: "/tl/appointment/clinic/:clinicId",
    component: _6811d80e,
    name: "appointment-clinic-clinicId___tl"
  }, {
    path: "/tl/appointment/menu/:menuId?",
    component: _21aa26a4,
    name: "appointment-menu-menuId___tl"
  }, {
    path: "/tl/form/clinic/:clinicId",
    component: _43b460ee,
    name: "form-clinic-clinicId___tl"
  }, {
    path: "/vi/appointment/clinic/:clinicId",
    component: _6811d80e,
    name: "appointment-clinic-clinicId___vi"
  }, {
    path: "/vi/appointment/menu/:menuId?",
    component: _21aa26a4,
    name: "appointment-menu-menuId___vi"
  }, {
    path: "/vi/form/clinic/:clinicId",
    component: _43b460ee,
    name: "form-clinic-clinicId___vi"
  }, {
    path: "/zhCn/appointment/clinic/:clinicId",
    component: _6811d80e,
    name: "appointment-clinic-clinicId___zhCn"
  }, {
    path: "/zhCn/appointment/menu/:menuId?",
    component: _21aa26a4,
    name: "appointment-menu-menuId___zhCn"
  }, {
    path: "/zhCn/form/clinic/:clinicId",
    component: _43b460ee,
    name: "form-clinic-clinicId___zhCn"
  }, {
    path: "/zhTw/appointment/clinic/:clinicId",
    component: _6811d80e,
    name: "appointment-clinic-clinicId___zhTw"
  }, {
    path: "/zhTw/appointment/menu/:menuId?",
    component: _21aa26a4,
    name: "appointment-menu-menuId___zhTw"
  }, {
    path: "/zhTw/form/clinic/:clinicId",
    component: _43b460ee,
    name: "form-clinic-clinicId___zhTw"
  }, {
    path: "/en/appointment/visits/:appointmentId/cancel",
    component: _91046ffc,
    name: "appointment-visits-appointmentId-cancel___en"
  }, {
    path: "/en/appointment/visits/:appointmentId/canceled",
    component: _2be8baa1,
    name: "appointment-visits-appointmentId-canceled___en"
  }, {
    path: "/es/appointment/visits/:appointmentId/cancel",
    component: _91046ffc,
    name: "appointment-visits-appointmentId-cancel___es"
  }, {
    path: "/es/appointment/visits/:appointmentId/canceled",
    component: _2be8baa1,
    name: "appointment-visits-appointmentId-canceled___es"
  }, {
    path: "/fr/appointment/visits/:appointmentId/cancel",
    component: _91046ffc,
    name: "appointment-visits-appointmentId-cancel___fr"
  }, {
    path: "/fr/appointment/visits/:appointmentId/canceled",
    component: _2be8baa1,
    name: "appointment-visits-appointmentId-canceled___fr"
  }, {
    path: "/ko/appointment/visits/:appointmentId/cancel",
    component: _91046ffc,
    name: "appointment-visits-appointmentId-cancel___ko"
  }, {
    path: "/ko/appointment/visits/:appointmentId/canceled",
    component: _2be8baa1,
    name: "appointment-visits-appointmentId-canceled___ko"
  }, {
    path: "/ne/appointment/visits/:appointmentId/cancel",
    component: _91046ffc,
    name: "appointment-visits-appointmentId-cancel___ne"
  }, {
    path: "/ne/appointment/visits/:appointmentId/canceled",
    component: _2be8baa1,
    name: "appointment-visits-appointmentId-canceled___ne"
  }, {
    path: "/pt/appointment/visits/:appointmentId/cancel",
    component: _91046ffc,
    name: "appointment-visits-appointmentId-cancel___pt"
  }, {
    path: "/pt/appointment/visits/:appointmentId/canceled",
    component: _2be8baa1,
    name: "appointment-visits-appointmentId-canceled___pt"
  }, {
    path: "/th/appointment/visits/:appointmentId/cancel",
    component: _91046ffc,
    name: "appointment-visits-appointmentId-cancel___th"
  }, {
    path: "/th/appointment/visits/:appointmentId/canceled",
    component: _2be8baa1,
    name: "appointment-visits-appointmentId-canceled___th"
  }, {
    path: "/tl/appointment/visits/:appointmentId/cancel",
    component: _91046ffc,
    name: "appointment-visits-appointmentId-cancel___tl"
  }, {
    path: "/tl/appointment/visits/:appointmentId/canceled",
    component: _2be8baa1,
    name: "appointment-visits-appointmentId-canceled___tl"
  }, {
    path: "/vi/appointment/visits/:appointmentId/cancel",
    component: _91046ffc,
    name: "appointment-visits-appointmentId-cancel___vi"
  }, {
    path: "/vi/appointment/visits/:appointmentId/canceled",
    component: _2be8baa1,
    name: "appointment-visits-appointmentId-canceled___vi"
  }, {
    path: "/zhCn/appointment/visits/:appointmentId/cancel",
    component: _91046ffc,
    name: "appointment-visits-appointmentId-cancel___zhCn"
  }, {
    path: "/zhCn/appointment/visits/:appointmentId/canceled",
    component: _2be8baa1,
    name: "appointment-visits-appointmentId-canceled___zhCn"
  }, {
    path: "/zhTw/appointment/visits/:appointmentId/cancel",
    component: _91046ffc,
    name: "appointment-visits-appointmentId-cancel___zhTw"
  }, {
    path: "/zhTw/appointment/visits/:appointmentId/canceled",
    component: _2be8baa1,
    name: "appointment-visits-appointmentId-canceled___zhTw"
  }, {
    path: "/en/appointment/schedule/:scheduleId?/:index?/confirm",
    component: _94f1f3e2,
    name: "appointment-schedule-scheduleId-index-confirm___en"
  }, {
    path: "/en/appointment/schedule/:scheduleId?/:index?/patient-info",
    component: _d58a6892,
    name: "appointment-schedule-scheduleId-index-patient-info___en"
  }, {
    path: "/es/appointment/schedule/:scheduleId?/:index?/confirm",
    component: _94f1f3e2,
    name: "appointment-schedule-scheduleId-index-confirm___es"
  }, {
    path: "/es/appointment/schedule/:scheduleId?/:index?/patient-info",
    component: _d58a6892,
    name: "appointment-schedule-scheduleId-index-patient-info___es"
  }, {
    path: "/fr/appointment/schedule/:scheduleId?/:index?/confirm",
    component: _94f1f3e2,
    name: "appointment-schedule-scheduleId-index-confirm___fr"
  }, {
    path: "/fr/appointment/schedule/:scheduleId?/:index?/patient-info",
    component: _d58a6892,
    name: "appointment-schedule-scheduleId-index-patient-info___fr"
  }, {
    path: "/ko/appointment/schedule/:scheduleId?/:index?/confirm",
    component: _94f1f3e2,
    name: "appointment-schedule-scheduleId-index-confirm___ko"
  }, {
    path: "/ko/appointment/schedule/:scheduleId?/:index?/patient-info",
    component: _d58a6892,
    name: "appointment-schedule-scheduleId-index-patient-info___ko"
  }, {
    path: "/ne/appointment/schedule/:scheduleId?/:index?/confirm",
    component: _94f1f3e2,
    name: "appointment-schedule-scheduleId-index-confirm___ne"
  }, {
    path: "/ne/appointment/schedule/:scheduleId?/:index?/patient-info",
    component: _d58a6892,
    name: "appointment-schedule-scheduleId-index-patient-info___ne"
  }, {
    path: "/pt/appointment/schedule/:scheduleId?/:index?/confirm",
    component: _94f1f3e2,
    name: "appointment-schedule-scheduleId-index-confirm___pt"
  }, {
    path: "/pt/appointment/schedule/:scheduleId?/:index?/patient-info",
    component: _d58a6892,
    name: "appointment-schedule-scheduleId-index-patient-info___pt"
  }, {
    path: "/th/appointment/schedule/:scheduleId?/:index?/confirm",
    component: _94f1f3e2,
    name: "appointment-schedule-scheduleId-index-confirm___th"
  }, {
    path: "/th/appointment/schedule/:scheduleId?/:index?/patient-info",
    component: _d58a6892,
    name: "appointment-schedule-scheduleId-index-patient-info___th"
  }, {
    path: "/tl/appointment/schedule/:scheduleId?/:index?/confirm",
    component: _94f1f3e2,
    name: "appointment-schedule-scheduleId-index-confirm___tl"
  }, {
    path: "/tl/appointment/schedule/:scheduleId?/:index?/patient-info",
    component: _d58a6892,
    name: "appointment-schedule-scheduleId-index-patient-info___tl"
  }, {
    path: "/vi/appointment/schedule/:scheduleId?/:index?/confirm",
    component: _94f1f3e2,
    name: "appointment-schedule-scheduleId-index-confirm___vi"
  }, {
    path: "/vi/appointment/schedule/:scheduleId?/:index?/patient-info",
    component: _d58a6892,
    name: "appointment-schedule-scheduleId-index-patient-info___vi"
  }, {
    path: "/zhCn/appointment/schedule/:scheduleId?/:index?/confirm",
    component: _94f1f3e2,
    name: "appointment-schedule-scheduleId-index-confirm___zhCn"
  }, {
    path: "/zhCn/appointment/schedule/:scheduleId?/:index?/patient-info",
    component: _d58a6892,
    name: "appointment-schedule-scheduleId-index-patient-info___zhCn"
  }, {
    path: "/zhTw/appointment/schedule/:scheduleId?/:index?/confirm",
    component: _94f1f3e2,
    name: "appointment-schedule-scheduleId-index-confirm___zhTw"
  }, {
    path: "/zhTw/appointment/schedule/:scheduleId?/:index?/patient-info",
    component: _d58a6892,
    name: "appointment-schedule-scheduleId-index-patient-info___zhTw"
  }, {
    path: "/en/appointment/reschedule/:appointmentId?/:scheduleId?/:index?/confirm",
    component: _3fcd606c,
    name: "appointment-reschedule-appointmentId-scheduleId-index-confirm___en"
  }, {
    path: "/en/appointment/schedule/:scheduleId?/:index?/:appointmentId?/confirmed",
    component: _2d0b4aac,
    name: "appointment-schedule-scheduleId-index-appointmentId-confirmed___en"
  }, {
    path: "/es/appointment/reschedule/:appointmentId?/:scheduleId?/:index?/confirm",
    component: _3fcd606c,
    name: "appointment-reschedule-appointmentId-scheduleId-index-confirm___es"
  }, {
    path: "/es/appointment/schedule/:scheduleId?/:index?/:appointmentId?/confirmed",
    component: _2d0b4aac,
    name: "appointment-schedule-scheduleId-index-appointmentId-confirmed___es"
  }, {
    path: "/fr/appointment/reschedule/:appointmentId?/:scheduleId?/:index?/confirm",
    component: _3fcd606c,
    name: "appointment-reschedule-appointmentId-scheduleId-index-confirm___fr"
  }, {
    path: "/fr/appointment/schedule/:scheduleId?/:index?/:appointmentId?/confirmed",
    component: _2d0b4aac,
    name: "appointment-schedule-scheduleId-index-appointmentId-confirmed___fr"
  }, {
    path: "/ko/appointment/reschedule/:appointmentId?/:scheduleId?/:index?/confirm",
    component: _3fcd606c,
    name: "appointment-reschedule-appointmentId-scheduleId-index-confirm___ko"
  }, {
    path: "/ko/appointment/schedule/:scheduleId?/:index?/:appointmentId?/confirmed",
    component: _2d0b4aac,
    name: "appointment-schedule-scheduleId-index-appointmentId-confirmed___ko"
  }, {
    path: "/ne/appointment/reschedule/:appointmentId?/:scheduleId?/:index?/confirm",
    component: _3fcd606c,
    name: "appointment-reschedule-appointmentId-scheduleId-index-confirm___ne"
  }, {
    path: "/ne/appointment/schedule/:scheduleId?/:index?/:appointmentId?/confirmed",
    component: _2d0b4aac,
    name: "appointment-schedule-scheduleId-index-appointmentId-confirmed___ne"
  }, {
    path: "/pt/appointment/reschedule/:appointmentId?/:scheduleId?/:index?/confirm",
    component: _3fcd606c,
    name: "appointment-reschedule-appointmentId-scheduleId-index-confirm___pt"
  }, {
    path: "/pt/appointment/schedule/:scheduleId?/:index?/:appointmentId?/confirmed",
    component: _2d0b4aac,
    name: "appointment-schedule-scheduleId-index-appointmentId-confirmed___pt"
  }, {
    path: "/th/appointment/reschedule/:appointmentId?/:scheduleId?/:index?/confirm",
    component: _3fcd606c,
    name: "appointment-reschedule-appointmentId-scheduleId-index-confirm___th"
  }, {
    path: "/th/appointment/schedule/:scheduleId?/:index?/:appointmentId?/confirmed",
    component: _2d0b4aac,
    name: "appointment-schedule-scheduleId-index-appointmentId-confirmed___th"
  }, {
    path: "/tl/appointment/reschedule/:appointmentId?/:scheduleId?/:index?/confirm",
    component: _3fcd606c,
    name: "appointment-reschedule-appointmentId-scheduleId-index-confirm___tl"
  }, {
    path: "/tl/appointment/schedule/:scheduleId?/:index?/:appointmentId?/confirmed",
    component: _2d0b4aac,
    name: "appointment-schedule-scheduleId-index-appointmentId-confirmed___tl"
  }, {
    path: "/vi/appointment/reschedule/:appointmentId?/:scheduleId?/:index?/confirm",
    component: _3fcd606c,
    name: "appointment-reschedule-appointmentId-scheduleId-index-confirm___vi"
  }, {
    path: "/vi/appointment/schedule/:scheduleId?/:index?/:appointmentId?/confirmed",
    component: _2d0b4aac,
    name: "appointment-schedule-scheduleId-index-appointmentId-confirmed___vi"
  }, {
    path: "/zhCn/appointment/reschedule/:appointmentId?/:scheduleId?/:index?/confirm",
    component: _3fcd606c,
    name: "appointment-reschedule-appointmentId-scheduleId-index-confirm___zhCn"
  }, {
    path: "/zhCn/appointment/schedule/:scheduleId?/:index?/:appointmentId?/confirmed",
    component: _2d0b4aac,
    name: "appointment-schedule-scheduleId-index-appointmentId-confirmed___zhCn"
  }, {
    path: "/zhTw/appointment/reschedule/:appointmentId?/:scheduleId?/:index?/confirm",
    component: _3fcd606c,
    name: "appointment-reschedule-appointmentId-scheduleId-index-confirm___zhTw"
  }, {
    path: "/zhTw/appointment/schedule/:scheduleId?/:index?/:appointmentId?/confirmed",
    component: _2d0b4aac,
    name: "appointment-schedule-scheduleId-index-appointmentId-confirmed___zhTw"
  }, {
    path: "/appointment/clinic/:clinicId",
    component: _6811d80e,
    name: "appointment-clinic-clinicId___ja"
  }, {
    path: "/appointment/menu/:menuId?",
    component: _21aa26a4,
    name: "appointment-menu-menuId___ja"
  }, {
    path: "/en/s/:shortLinkPath?",
    component: _faf0353a,
    name: "s-shortLinkPath___en"
  }, {
    path: "/es/s/:shortLinkPath?",
    component: _faf0353a,
    name: "s-shortLinkPath___es"
  }, {
    path: "/form/clinic/:clinicId",
    component: _43b460ee,
    name: "form-clinic-clinicId___ja"
  }, {
    path: "/fr/s/:shortLinkPath?",
    component: _faf0353a,
    name: "s-shortLinkPath___fr"
  }, {
    path: "/ko/s/:shortLinkPath?",
    component: _faf0353a,
    name: "s-shortLinkPath___ko"
  }, {
    path: "/ne/s/:shortLinkPath?",
    component: _faf0353a,
    name: "s-shortLinkPath___ne"
  }, {
    path: "/pt/s/:shortLinkPath?",
    component: _faf0353a,
    name: "s-shortLinkPath___pt"
  }, {
    path: "/th/s/:shortLinkPath?",
    component: _faf0353a,
    name: "s-shortLinkPath___th"
  }, {
    path: "/tl/s/:shortLinkPath?",
    component: _faf0353a,
    name: "s-shortLinkPath___tl"
  }, {
    path: "/vi/s/:shortLinkPath?",
    component: _faf0353a,
    name: "s-shortLinkPath___vi"
  }, {
    path: "/zhCn/s/:shortLinkPath?",
    component: _faf0353a,
    name: "s-shortLinkPath___zhCn"
  }, {
    path: "/zhTw/s/:shortLinkPath?",
    component: _faf0353a,
    name: "s-shortLinkPath___zhTw"
  }, {
    path: "/appointment/visits/:appointmentId/cancel",
    component: _91046ffc,
    name: "appointment-visits-appointmentId-cancel___ja"
  }, {
    path: "/appointment/visits/:appointmentId/canceled",
    component: _2be8baa1,
    name: "appointment-visits-appointmentId-canceled___ja"
  }, {
    path: "/en/form/:formId/confirm",
    component: _5dcc4f6f,
    name: "form-formId-confirm___en"
  }, {
    path: "/en/form/:formId/loadBackup",
    component: _400f4f69,
    name: "form-formId-loadBackup___en"
  }, {
    path: "/en/form/:formId/sent",
    component: _f511210e,
    name: "form-formId-sent___en"
  }, {
    path: "/es/form/:formId/confirm",
    component: _5dcc4f6f,
    name: "form-formId-confirm___es"
  }, {
    path: "/es/form/:formId/loadBackup",
    component: _400f4f69,
    name: "form-formId-loadBackup___es"
  }, {
    path: "/es/form/:formId/sent",
    component: _f511210e,
    name: "form-formId-sent___es"
  }, {
    path: "/fr/form/:formId/confirm",
    component: _5dcc4f6f,
    name: "form-formId-confirm___fr"
  }, {
    path: "/fr/form/:formId/loadBackup",
    component: _400f4f69,
    name: "form-formId-loadBackup___fr"
  }, {
    path: "/fr/form/:formId/sent",
    component: _f511210e,
    name: "form-formId-sent___fr"
  }, {
    path: "/ko/form/:formId/confirm",
    component: _5dcc4f6f,
    name: "form-formId-confirm___ko"
  }, {
    path: "/ko/form/:formId/loadBackup",
    component: _400f4f69,
    name: "form-formId-loadBackup___ko"
  }, {
    path: "/ko/form/:formId/sent",
    component: _f511210e,
    name: "form-formId-sent___ko"
  }, {
    path: "/ne/form/:formId/confirm",
    component: _5dcc4f6f,
    name: "form-formId-confirm___ne"
  }, {
    path: "/ne/form/:formId/loadBackup",
    component: _400f4f69,
    name: "form-formId-loadBackup___ne"
  }, {
    path: "/ne/form/:formId/sent",
    component: _f511210e,
    name: "form-formId-sent___ne"
  }, {
    path: "/pt/form/:formId/confirm",
    component: _5dcc4f6f,
    name: "form-formId-confirm___pt"
  }, {
    path: "/pt/form/:formId/loadBackup",
    component: _400f4f69,
    name: "form-formId-loadBackup___pt"
  }, {
    path: "/pt/form/:formId/sent",
    component: _f511210e,
    name: "form-formId-sent___pt"
  }, {
    path: "/th/form/:formId/confirm",
    component: _5dcc4f6f,
    name: "form-formId-confirm___th"
  }, {
    path: "/th/form/:formId/loadBackup",
    component: _400f4f69,
    name: "form-formId-loadBackup___th"
  }, {
    path: "/th/form/:formId/sent",
    component: _f511210e,
    name: "form-formId-sent___th"
  }, {
    path: "/tl/form/:formId/confirm",
    component: _5dcc4f6f,
    name: "form-formId-confirm___tl"
  }, {
    path: "/tl/form/:formId/loadBackup",
    component: _400f4f69,
    name: "form-formId-loadBackup___tl"
  }, {
    path: "/tl/form/:formId/sent",
    component: _f511210e,
    name: "form-formId-sent___tl"
  }, {
    path: "/vi/form/:formId/confirm",
    component: _5dcc4f6f,
    name: "form-formId-confirm___vi"
  }, {
    path: "/vi/form/:formId/loadBackup",
    component: _400f4f69,
    name: "form-formId-loadBackup___vi"
  }, {
    path: "/vi/form/:formId/sent",
    component: _f511210e,
    name: "form-formId-sent___vi"
  }, {
    path: "/zhCn/form/:formId/confirm",
    component: _5dcc4f6f,
    name: "form-formId-confirm___zhCn"
  }, {
    path: "/zhCn/form/:formId/loadBackup",
    component: _400f4f69,
    name: "form-formId-loadBackup___zhCn"
  }, {
    path: "/zhCn/form/:formId/sent",
    component: _f511210e,
    name: "form-formId-sent___zhCn"
  }, {
    path: "/zhTw/form/:formId/confirm",
    component: _5dcc4f6f,
    name: "form-formId-confirm___zhTw"
  }, {
    path: "/zhTw/form/:formId/loadBackup",
    component: _400f4f69,
    name: "form-formId-loadBackup___zhTw"
  }, {
    path: "/zhTw/form/:formId/sent",
    component: _f511210e,
    name: "form-formId-sent___zhTw"
  }, {
    path: "/en/form/:formId/:pageId",
    component: _b8619c4a,
    name: "form-formId-pageId___en"
  }, {
    path: "/es/form/:formId/:pageId",
    component: _b8619c4a,
    name: "form-formId-pageId___es"
  }, {
    path: "/fr/form/:formId/:pageId",
    component: _b8619c4a,
    name: "form-formId-pageId___fr"
  }, {
    path: "/ko/form/:formId/:pageId",
    component: _b8619c4a,
    name: "form-formId-pageId___ko"
  }, {
    path: "/ne/form/:formId/:pageId",
    component: _b8619c4a,
    name: "form-formId-pageId___ne"
  }, {
    path: "/pt/form/:formId/:pageId",
    component: _b8619c4a,
    name: "form-formId-pageId___pt"
  }, {
    path: "/th/form/:formId/:pageId",
    component: _b8619c4a,
    name: "form-formId-pageId___th"
  }, {
    path: "/tl/form/:formId/:pageId",
    component: _b8619c4a,
    name: "form-formId-pageId___tl"
  }, {
    path: "/vi/form/:formId/:pageId",
    component: _b8619c4a,
    name: "form-formId-pageId___vi"
  }, {
    path: "/zhCn/form/:formId/:pageId",
    component: _b8619c4a,
    name: "form-formId-pageId___zhCn"
  }, {
    path: "/zhTw/form/:formId/:pageId",
    component: _b8619c4a,
    name: "form-formId-pageId___zhTw"
  }, {
    path: "/appointment/schedule/:scheduleId?/:index?/confirm",
    component: _94f1f3e2,
    name: "appointment-schedule-scheduleId-index-confirm___ja"
  }, {
    path: "/appointment/schedule/:scheduleId?/:index?/patient-info",
    component: _d58a6892,
    name: "appointment-schedule-scheduleId-index-patient-info___ja"
  }, {
    path: "/appointment/reschedule/:appointmentId?/:scheduleId?/:index?/confirm",
    component: _3fcd606c,
    name: "appointment-reschedule-appointmentId-scheduleId-index-confirm___ja"
  }, {
    path: "/appointment/schedule/:scheduleId?/:index?/:appointmentId?/confirmed",
    component: _2d0b4aac,
    name: "appointment-schedule-scheduleId-index-appointmentId-confirmed___ja"
  }, {
    path: "/s/:shortLinkPath?",
    component: _faf0353a,
    name: "s-shortLinkPath___ja"
  }, {
    path: "/form/:formId/confirm",
    component: _5dcc4f6f,
    name: "form-formId-confirm___ja"
  }, {
    path: "/form/:formId/loadBackup",
    component: _400f4f69,
    name: "form-formId-loadBackup___ja"
  }, {
    path: "/form/:formId/sent",
    component: _f511210e,
    name: "form-formId-sent___ja"
  }, {
    path: "/form/:formId/:pageId",
    component: _b8619c4a,
    name: "form-formId-pageId___ja"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
